import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateServiceCategory } from 'API/ServiceCategories/updateServiceCategory';

const useUpdateServiceCategory = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const update = async (serviceCategoryData) => {
        const response = await updateServiceCategory(serviceCategoryData);
        return response.data;
    };

    return useMutation({
        mutationFn: update,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['ServiceCategories'] });
            queryClient.invalidateQueries({
                queryKey: ['ServiceCategory', variables.id],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useUpdateServiceCategory;
